import { useQuery } from '@tanstack/react-query';
import { fetchIntegrationCompanies } from '../../api/integrationCompanies';
import type { IntegrationCompaniesResponse } from '../types';

type UseIntegrationCompaniesParams = {
  baseUrl: string;
  nonce: string;
  connectionId: string;
  q: string;
  page: number;
  perPage: number;
  enabled?: boolean;
};

export const useIntegrationCompanies = ({
  baseUrl,
  nonce,
  connectionId,
  q,
  page,
  perPage,
  enabled = true,
}: UseIntegrationCompaniesParams) =>
  useQuery<IntegrationCompaniesResponse>({
    queryKey: ['integration-companies', connectionId, q, page, perPage],
    queryFn: () =>
      fetchIntegrationCompanies(
        { baseUrl, nonce },
        {
          connectionId,
          q,
          page,
          perPage,
        },
      ),
    enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
